import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getLatestUpdates, markUpdatesAsSeen } from '../services/updates.service';

type UseLatestUpdatesResult = {
    updates: any[];
    unreadCount: number;
};

export const useLatestUpdates = (limit?: number) => {
    return useQuery<UseLatestUpdatesResult>({
        queryKey: ['updates', 'latest', limit],
        queryFn: async () => {
            const res = await getLatestUpdates(limit);
            // backend responds with { data: { updates, unreadCount } }
            return res?.data?.data ?? res?.data;
        },
    });
};

export const useMarkUpdatesAsSeen = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async () => {
            const res = await markUpdatesAsSeen();
            return res?.data?.data ?? res?.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['updates', 'latest'] });
        },
    });
};

